<app-header-scania *ngIf="(uiVersion$ | async) === 'scania'; else defaultHeader"></app-header-scania>
<ng-template #defaultHeader>
  <app-header-default></app-header-default>
</ng-template>
